import React, { useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, LabelList } from 'recharts';
import { fetchRegionStock } from '../../services/sursysLogisticAPI';
import { Package } from 'lucide-react';

const StockOverviewWidget = ({ filters }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [localFilter, setLocalFilter] = useState('All');

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        // In real app, pass both global filters and localFilter
        const res = await fetchRegionStock({ ...filters, time: localFilter });
        setData(res);
      } catch (error) {
        console.error("Failed to fetch stock", error);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [filters, localFilter]);

  return (
    <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', height: '100%' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px', gap: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Package size={20} color="#3b82f6" />
          <h2 style={{ margin: 0, fontSize: '16px', fontWeight: '700', color: '#1e293b' }}>Top 10 Produk</h2>
        </div>
        
        <div style={{ display: 'flex', background: '#f8fafc', padding: '4px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
          {['All', 'Per Month', 'Per Year'].map(f => (
            <button
              key={f}
              onClick={() => setLocalFilter(f)}
              style={{
                padding: '6px 16px', fontSize: '13px', fontWeight: '600', borderRadius: '6px', cursor: 'pointer', border: 'none',
                background: localFilter === f ? '#fff' : 'transparent',
                color: localFilter === f ? '#0f172a' : '#64748b',
                boxShadow: localFilter === f ? '0 1px 2px rgba(0,0,0,0.05)' : 'none',
                transition: 'all 0.2s ease'
              }}
            >
              {f}
            </button>
          ))}
        </div>
      </div>

      <div style={{ height: '400px', width: '100%' }}>
        {loading ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', justifyContent: 'center', height: '100%' }}>
            {[...Array(8)].map((_, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '16px', animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite' }}>
                <div style={{ width: '120px', height: '16px', background: '#e2e8f0', borderRadius: '4px' }}></div>
                <div style={{ height: '24px', background: '#dbeafe', borderRadius: '4px', width: `${Math.max(20, 100 - i * 10)}%` }}></div>
              </div>
            ))}
          </div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={data}
              layout="vertical"
              margin={{ top: 5, right: 50, left: 0, bottom: 5 }}
              barSize={20}
            >
              <XAxis type="number" hide />
              <YAxis 
                type="category" 
                dataKey="name" 
                axisLine={true} 
                tickLine={true} 
                tick={{ fill: '#64748b', fontSize: 12 }} 
                width={150} 
              />
              <Tooltip 
                cursor={{ fill: '#f8fafc' }}
                contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
              />
              <Bar dataKey="value" fill="#3b82f6" radius={[0, 4, 4, 0]}>
                <LabelList 
                  dataKey="formatted" 
                  position="right" 
                  style={{ fill: '#64748b', fontSize: 12, fontWeight: 500 }} 
                />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: .5; }
        }
      `}</style>
    </div>
  );
};

export default StockOverviewWidget;
